import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Text,
  Flex,
  Spinner,
  Icon,
  Divider,
  Box,
} from "@chakra-ui/react";
import { AiFillCheckCircle, AiFillCloseCircle } from "react-icons/ai";

// Config
import { chainConfig } from "config/chain";

// Hooks
import useMaxDefiStrategy from "hooks/useMaxDefiStrategy";

// Constants
import { CLICK_MAX_YIELD } from "constants/analytics";

// Hooks
import useApp from "hooks/useApp";

import { Props } from "./Props.type";

const TransactionModal = ({
  isOpen,
  hash,
  error,
  isTxnProcessing,
  closeAlert,
  handleTxView,
  showStrategy,
}: Props) => {
  const { track } = useApp();
  const { maxYieldStrategy } = useMaxDefiStrategy();

  const renderContent = () => {
    if (error) {
      return (
        <>
          <Icon as={AiFillCloseCircle} color="#E53E3E" fontSize="5rem" />
          <Text fontSize="16px">Transaction Failed</Text>
          {hash ? (
            <Text
              fontSize="14px"
              color="brand.primary"
              fontFamily="medium"
              cursor="pointer"
              onClick={() => handleTxView()}
            >
              View on {chainConfig.blockExplorers?.default.name}
            </Text>
          ) : (
            <Text fontSize="14px" fontFamily="medium" textAlign="center">
              {error}
            </Text>
          )}
        </>
      );
    } else if (hash && !error) {
      if (isTxnProcessing) {
        return (
          <>
            <Spinner size="xl" color="brand.primary" />
            <Text fontSize={16}>Transaction Submitted.</Text>
            <Text fontSize={14}>Waiting for confirmation. Please Wait!</Text>
            <Text
              fontSize="14px"
              color="brand.primary"
              fontFamily="medium"
              cursor="pointer"
              onClick={() => handleTxView()}
            >
              View on {chainConfig.blockExplorers?.default.name}
            </Text>
          </>
        );
      } else {
        return (
          <>
            <Icon as={AiFillCheckCircle} color="#38A169" fontSize="5rem" />
            <Text fontSize={16}>Transaction Successful.</Text>
            <Text
              fontSize={14}
              color="brand.primary"
              fontFamily="medium"
              cursor="pointer"
              onClick={() => handleTxView()}
            >
              View on {chainConfig.blockExplorers?.default.name}
            </Text>
            {showStrategy && (
              <>
                <Divider borderColor="brand.separator" my="0.5rem" />
                <Flex
                  w="100%"
                  align="center"
                  justifyContent="space-between"
                  fontSize={{ base: "14px", lg: "1rem" }}
                  gap="0.5rem"
                >
                  <Box maxW="120px">
                    <Text>Earn max yield on BNBx</Text>
                  </Box>
                  <Box
                    as="a"
                    minW="120px"
                    borderRadius="0.5rem"
                    color="brand.primary"
                    bg="white"
                    cursor="pointer"
                    p={{ base: "0.5rem 1rem", lg: "0.5rem 2rem" }}
                    border="1px solid"
                    fontFamily="semi-bold"
                    borderColor="brand.separator"
                    fontSize="14px"
                    href={maxYieldStrategy}
                    onClick={() =>
                      track(CLICK_MAX_YIELD, {
                        location: "Transaction Popup",
                      })
                    }
                    target="_blank"
                    rel="noreferrer"
                  >
                    Know More
                  </Box>
                </Flex>
              </>
            )}
          </>
        );
      }
    } else {
      return (
        <>
          <Spinner size="xl" color="brand.primary" />
          <Text fontSize={14} textAlign="center">
            Please check your wallet for prompt.
          </Text>
        </>
      );
    }
  };
  return (
    <Modal isOpen={isOpen} onClose={closeAlert} isCentered>
      <ModalOverlay />
      <ModalContent w="394px" bg="brand.backgroundLight" m="0.5rem">
        <ModalHeader fontSize="1rem" fontFamily="semi-bold">
          Transaction
        </ModalHeader>
        <ModalCloseButton
          _focus={{
            boxShadow: "none",
          }}
        />
        <ModalBody py="0" pb="0.5rem">
          <Flex
            flexDir="column"
            justifyContent="center"
            alignItems="center"
            padding="1rem"
            gap="1rem"
          >
            {renderContent()}
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default TransactionModal;
